import React from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { getCspNonce } from "@/utils/csp_nonce";

export const EmotionCacheProvider = ({ children }: { children: React.ReactNode }) => {
  const nonce = getCspNonce();

  const cache = React.useMemo(
    () =>
      createCache({
        key: "overwritable",
        nonce: nonce || undefined,
        prepend: true,
        container: document.head,
      }),
    [nonce],
  );

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};
